import { MARK_PATH } from './Logo';
import './BrandBackdrop.css';

const VIEWBOX = '8.6 9.2 64.6 69.8';
const LAYERS = 18;   // extrusion depth, in stacked copies
const STEP = 6.0;    // px between layers along Z

function mix(a, b, t) {
  const pa = [parseInt(a.slice(1, 3), 16), parseInt(a.slice(3, 5), 16), parseInt(a.slice(5, 7), 16)];
  const pb = [parseInt(b.slice(1, 3), 16), parseInt(b.slice(3, 5), 16), parseInt(b.slice(5, 7), 16)];
  const c = pa.map((v, i) => Math.round(v + (pb[i] - v) * t));
  return `rgb(${c[0]}, ${c[1]}, ${c[2]})`;
}

const BACK = '#0E0C18';   // near-bg back of the extrusion
const FRONT = '#39431F';  // muted dark-lime front face (un-lit base)

export default function BrandBackdrop() {
  return (
    <div className="gw-bd" aria-hidden="true">
      <div className="gw-bd__wash" />
      <div className="gw-bd__scene">
        <div className="gw-bd__mark">
          {Array.from({ length: LAYERS }).map((_, i) => {
            const t = i / (LAYERS - 1);
            const front = i === LAYERS - 1;
            if (front) {
              // Smooth glossy front face: a static base sheen plus a green
              // highlight that drifts across it, driven by a CSS keyframe
              // (reliable + instant, unlike SMIL). Clipped to the mark; the
              // clip is SVG-internal so the 3D stack stays intact.
              return (
                <svg key={i} className="gw-bd__layer" viewBox={VIEWBOX}
                  style={{ transform: `translateZ(${i * STEP}px)` }}>
                  <defs>
                    <linearGradient id="gwBase" x1="0" y1="0" x2="1" y2="1">
                      <stop offset="0%" stopColor="#4d5d26" />
                      <stop offset="55%" stopColor="#36411D" />
                      <stop offset="100%" stopColor="#2A331A" />
                    </linearGradient>
                    <radialGradient id="gwBlob">
                      <stop offset="0%" stopColor="#DCF85E" />
                      <stop offset="34%" stopColor="rgba(198,236,74,0.70)" />
                      <stop offset="70%" stopColor="rgba(136,176,44,0.14)" />
                      <stop offset="100%" stopColor="rgba(136,176,44,0)" />
                    </radialGradient>
                    <clipPath id="gwClip"><path d={MARK_PATH} /></clipPath>
                  </defs>
                  <path d={MARK_PATH} fill="url(#gwBase)" />
                  <g clipPath="url(#gwClip)">
                    <circle className="gw-bd__beam" cx="41" cy="44" r="30" fill="url(#gwBlob)" />
                  </g>
                </svg>
              );
            }
            return (
              <svg key={i} className="gw-bd__layer" viewBox={VIEWBOX}
                style={{ transform: `translateZ(${i * STEP}px)` }}>
                <path d={MARK_PATH} fill={mix(BACK, FRONT, t)} />
              </svg>
            );
          })}
        </div>
      </div>
    </div>
  );
}
